export default __webpack_public_path__ + "static/media/gallery_07.6d5212a4.jpg";